import React, { useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../Redux/Store/index.ts";
import { Col, Container, Row } from "react-bootstrap";
import SideBar from "../Components/SideBar.tsx";
import Header from "../Components/Header.tsx";
import "./Home.css";
import FiltroSidenav from "../Components/FiltroSidenav.tsx";
import Tabelle from "../Components/Table.tsx";
import { EventiColumns } from "../lib/ColonneTabelle.ts";
import { useNavigate } from "react-router-dom";
import { Eventi } from "../lib/interface.ts";

const EventiPage: React.FC = () => {
  const { eventi } = useSelector((state: RootState) => state.eventi);
  const { committenti } = useSelector((state: RootState) => state.committenti);
  const { contratti } = useSelector((state: RootState) => state.contratti);
  const { cantieri } = useSelector((state: RootState) => state.cantieri);
  const navigate = useNavigate();
  const [showFiltro, setShowFiltro] = useState(false);
  const [eventiTable, setEventiTable] = useState<Eventi[]>([]);
  const [eventiFiltrati, setEventiFiltrati] = useState<Eventi[]>([]);

  const formatDateIT = (isoDateString?: string): string => {
    if (!isoDateString) return "";
    const parts = isoDateString.split("-");
    if (parts.length !== 3) return isoDateString;
    const [yyyy, mm, dd] = parts;
    return `${dd}/${mm}/${yyyy}`;
  };

  // Trasforma i dati degli eventi aggiungendo i nomi dei committenti, contratti e cantieri
  const preparaEventiForTable = (eventi: Eventi[]): Eventi[] => {
    return eventi.map((evento) => ({
      ...evento,
      dataOra: formatDateIT(evento.dataOra),
      scadenza: formatDateIT(evento.scadenza),
      committente: committenti.find((c) => c.id === evento.committenteId)?.ragioneSociale || "-",
      contrattoQuadro: contratti.find((c) => c.id === evento.contrattoQuadroId)?.codice || "-",
      cantiere: cantieri.find((c) => c.id === evento.cantiereId)?.nome || "-",
    }));
  };

  useEffect(() => {
    const eventiForTable = preparaEventiForTable(eventi);
    setEventiTable(eventiForTable);
  }, [eventi]);

  useEffect(() => {
    if (eventiFiltrati.length > 0) setEventiTable(preparaEventiForTable(eventiFiltrati));
  }, [eventiFiltrati]);
  const handleFilterClick = () => setShowFiltro(true);
  const handleAddClick = () => navigate("/crea/eventi");

  return (
    <Container fluid className="d-flex justify-content-between" style={{ margin: "0", padding: "0" }}>
      <Container fluid style={{ margin: "0", padding: "0", width: "5%" }}>
        <SideBar />
      </Container>
      <Container fluid className="colonna">
        <div className="d-flex justify-content-center">
          <Header
            title="Eventi"
            buttons={[
              { label: "Filtra", onClick: handleFilterClick },
              { label: "Aggiungi un nuovo evento", onClick: handleAddClick },
            ]}
          />
        </div>

        <div className="d-flex justify-content-center">
          <div className="table-card">
            <Tabelle data={eventiTable} columns={EventiColumns} type={"eventi"} tableTitle="Eventi" />
          </div>
        </div>
      </Container>

      <FiltroSidenav visible={showFiltro} onHide={() => setShowFiltro(false)} setTable={(e) => setEventiFiltrati(e)} />
    </Container>
  );
};

export default EventiPage;
